var c = /* @__PURE__ */ ((I) => (I.WARNING = "warning", I.CRITICAL = "critical", I.HIGHLIGHT = "highlight", I.SUCCESS = "success", I))(c || {}), r = /* @__PURE__ */ ((I) => (I.DEFAULT = "default", I.TIP = "tip", I))(r || {});
export {
  c as AlertTypeOption,
  r as AlertVariantOption
};
